export default "__VITE_ASSET__C42EHuL0__"